// utils
import PadItemMatMed from '../components-js/pad-item/PadItemMatMed';

const TEMPLATE_NAME = 'PAD_CREATOR_ITEM_MATMED';

const initialState = {
  loading: false,
  errors: [],
  data: {
    loaded: [],
    screen: []
  }
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case `${TEMPLATE_NAME}_PENDING`: {
      const padCreatorMatMed = new PadItemMatMed(state);

      return padCreatorMatMed.setLoading().setErrors().getState();
    }

    case `${TEMPLATE_NAME}_REJECTED`: {
      const errors = action.payload.errors;

      const padCreatorMatMed = new PadItemMatMed(state);

      return padCreatorMatMed.setErrors(errors).setLoading(false).getState();
    }

    case `${TEMPLATE_NAME}_FULFILLED`: {
      const { matMeds, prescriptions, padDetails } = action.payload;

      const padCreatorMatMed = new PadItemMatMed(state);

      return padCreatorMatMed
        .prepare(matMeds, prescriptions, padDetails)
        .setLoading(false)
        .getState();
    }

    case `${TEMPLATE_NAME}_UPDATE`: {
      const { padPrescriptions, padDetails } = action.payload.data;

      const padCreatorMatMed = new PadItemMatMed(state);

      // prettier-ignore
      return padCreatorMatMed
        .update(padPrescriptions, padDetails)
        .getState();
    }

    case `${TEMPLATE_NAME}_RESET`: {
      return initialState;
    }

    default: {
      return state;
    }
  }
};

export default reducer;
